import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from "@angular/common/http";
import * as CarModels from "../../models/car/car";
import { EnvironmentService } from "../../../app/services/environment.service";
import { GarageSearchModel } from "../../models/garage/garageSearch";
import { HelperService } from "../helper/helper.service";
import * as Models from "../../models/commonModels";
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as DepositeModels from '../../models/deposite/deposite';
import * as TyreOrderModels from '../../models/tyre-order/tyre-order';
import * as RelocationOrderModels from '../../models/relocation-order/relocation-order';
import * as AldModels from '../../models/ald/ald';
import * as DepoisteModels from "../../models/deposite/deposite";
import * as GarageModels from "../../models/garage/garage";

@Injectable({
  providedIn: "root",
})
export class AldService {
  constructor(
    private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private helperService: HelperService
  ) { }


  public carSet(Car: Models.Request<CarModels.CarModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CarModels.CarModel>>(
      `${this.environmentService.getApiURL()}/ald/car-set`,
      Car,
      options
    );
  }

  public carGet(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<CarModels.CarModel>>(
      `${this.environmentService.getApiURL()}/ald/car-get`,
      Car,
      options
    );
  }

  public getMainVisits(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageVisitsModels.GarageVisitModel>>(`${this.environmentService.getApiURL()}/ald/main-visit-list`, Car, options);
  }

  public getDeposites(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<DepositeModels.DepositeModel>>(`${this.environmentService.getApiURL()}/ald/deposite-list`, Car, options);
  }

  public getDeposite(Deposite: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DepositeModels.DepositeModel>>(`${this.environmentService.getApiURL()}/ald/deposite-get`, Deposite, options);
  }

  public getTyreOrders(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreOrderModels.TyreOrderModel>>(`${this.environmentService.getApiURL()}/ald/tyre-order-list`, Car, options);
  }

  public getRelocationOrders(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<RelocationOrderModels.RelocationOrderModel>>(`${this.environmentService.getApiURL()}/ald/relocation-order-list`, Car, options);
  }

  public createGarageVisit(GarageVisit: Models.ContextRequest<CarModels.CarModel, GarageVisitsModels.GarageVisitModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitModel>>(`${this.environmentService.getApiURL()}/ald/garage-visit-create`, GarageVisit, options);
  }

  public summaryGet(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<AldModels.AldSummaryModel>>(
      `${this.environmentService.getApiURL()}/ald/summary-get`,
      Car,
      options
    );
  }

  public getTyreOrder(TyreOrder: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreOrderModels.TyreOrderModel>>(`${this.environmentService.getApiURL()}/ald/tyre-order-get`, TyreOrder, options);
  }

  public getRelocationOrder(RelocationOrder: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<RelocationOrderModels.RelocationOrderModel>>(`${this.environmentService.getApiURL()}/ald/relocation-order-get`, RelocationOrder, options);
  }

  public createRelocationOrder(RelocatoinOrder: Models.ContextRequest<DepoisteModels.DepositeModel, GarageModels.GaragePreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<RelocationOrderModels.RelocationOrderModel>>(`${this.environmentService.getApiURL()}/ald/relocation-order-create`, RelocatoinOrder, options);                                                                                                                                                                  
  }

  public getRelocationGarages(RelocatoinOrder: Models.Request<DepoisteModels.DepositeModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageModels.GaragePreviewModel>>(`${this.environmentService.getApiURL()}/ald/relocation-garage-list`, RelocatoinOrder, options);
  }

  public createGarageVisitRequestForDeposite(Deposite: Models.Request<DepoisteModels.DepositeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitRequestModel>>(`${this.environmentService.getApiURL()}/ald/garage-visit-request-for-deposite-create`, Deposite, options);
  }

  public createGarageVisitRequestForTyreOrder(TyreOrder: Models.Request<TyreOrderModels.TyreOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageVisitsModels.GarageVisitRequestModel>>(`${this.environmentService.getApiURL()}/ald/garage-visit-request-for-tyre-order-create`, TyreOrder, options);
  }

  public getAvailableDefaultGarages(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<GarageModels.GaragePreviewModel>>(`${this.environmentService.getApiURL()}/ald/available-default-garage-list`, Car, options);
  }

  public setDefaultGarage(Garage: Models.Request<GarageModels.GaragePreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<GarageModels.GaragePreviewModel>>(`${this.environmentService.getApiURL()}/ald/default-garage-set`, Garage, options);
  }

  public sendMessage(Message: Models.Request<string>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseBase>(`${this.environmentService.getApiURL()}/ald/send-message`, Message, options);
  }
}
